import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { AddChannelsToChannelGuideDocument } from './add-channels.generated';

export const useAddChannelsToChannelGuide = (
  options: ApiOptions<typeof AddChannelsToChannelGuideDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(AddChannelsToChannelGuideDocument, {
    ...useNotifications(AddChannelsToChannelGuideDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: (data) => {
        const count = data.addChannelsToChannelGuide?.addedIds.length ?? 0;
        const name = data.addChannelsToChannelGuide?.channelGuide.name;
        return t('api.channel_guides.add_channels_success_plural', { count, name });
      },
    }),

    ...options,
  });
};
